/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable functional/no-let */

import DOMPurify from 'dompurify'
import { isValidUrl } from '@ampdx/common-utils/src'
import { appMenuNames } from './constants'

export const getCWPEnvironmentForURL = (function () {
  const environments = [
    {
      name: 'localhost:6006',
      pattern: /^(http|https):?\/\/localhost:6006/,
    },
    {
      name: 'localhost:8080',
      pattern: /^(http|https):?\/\/localhost:8080\/site\/(ampmicrosites|joinameriprise)/,
    },
    {
      name: 'localhost:8081',
      pattern: /^(http|https):?\/\/localhost:8081\/site\/(ampmicrosites|joinameriprise)/,
    },
    {
      name: 'localhost:9100',
      pattern: /^(http|https):?\/\/localhost:9100/,
    },
    {
      name: 'localhostcms',
      pattern:
        /^(http|https):?\/\/localhost:(8080|8081)\/site\/_cmsinternal\/(ampmicrosites|joinameriprise)/,
    },
    {
      name: 'localhost:8080cms',
      pattern:
        /^(http|https):?\/\/localhost:8080\/site\/_cmsinternal\/(ampmicrosites|joinameriprise)/,
    },
    {
      name: 'localhost:8081cms',
      pattern:
        /^(http|https):?\/\/localhost:8081\/site\/_cmsinternal\/(ampmicrosites|joinameriprise)/,
    },
    {
      name: 'localhostpreview',
      pattern:
        /^(http|https):?\/\/localhost:(8080|8081)\/site\/(ampmicrosites|joinameriprise)\/preview/,
    },
    {
      name: 'devcms',
      pattern: /^(http|https):?\/\/cms-ws\d*\.dev\.ameriprise.com/,
    },
    {
      name: 'dev',
      pattern: /^(http|https):?\/\/www-ws\d*\.dev\.ameriprise.com\/(microsite|careers)/,
    },
    {
      name: 'devpreview',
      pattern: /^(http|https):?\/\/www-ws\d*\.dev\.ameriprise.com\/(microsite|careers)\/preview/,
    },
    {
      name: 'qawscms',
      pattern: /^(http|https):?\/\/cms-ws\d*\.qa\.ameriprise.com/,
    },
    {
      name: 'qaws',
      pattern: /^(http|https):?\/\/www-ws\d*\.qa\.ameriprise.com\/(microsite|careers)/,
    },
    {
      name: 'qawspreview',
      pattern: /^(http|https):?\/\/www-ws\d*\.qa\.ameriprise.com\/(microsite|careers)\/preview/,
    },
    {
      name: 'qacms',
      pattern: /^(http|https):?\/\/cms\.qa\.ameriprise.com/,
    },
    {
      name: 'qa',
      pattern: /^(http|https):?\/\/www\.qa\.ameriprise.com\/(microsite|careers)/,
    },
    {
      name: 'qapreview',
      pattern: /^(http|https):?\/\/www\.qa\.ameriprise.com\/(microsite|careers)\/preview/,
    },
    {
      name: 'prodcms',
      pattern: /^(http|https):?\/\/cms\.ameriprise.com/,
    },
    {
      name: 'prod',
      pattern: /^(http|https):?\/\/www\.ameriprise.com\/(microsite|careers)/,
    },
    {
      name: 'prodpreview',
      pattern: /^(http|https):?\/\/www\.ameriprise.com\/(microsite|careers)\/preview/,
    },
  ]

  return function getCWPEnvironmentForURL(url: string) {
    url = url || window.location.toString()

    let result

    environments.forEach(function (environment) {
      if (environment.pattern.test(url)) result = environment.name
    })

    result = result ?? 'prod'
    return result
  }
})()

export const APIENDPOINT = (env: string) => {
  let base = ''
  let baseGallery = ''
  let menuBase = ''
  let menuBaseWithParams = ''
  let advisor = ''
  switch (env) {
    case 'localhost:8080':
      base = 'http://localhost:8080/site/ampmicrosites/'
      baseGallery = '/site/binaries/'
      menuBase = 'http://localhost:8080/site/cfgapi/hst/menus/local-ampmicrosites/'
      menuBaseWithParams = 'http://localhost:8080/site/cfgapi/hst/menus-ext/local-ampmicrosites/'
      advisor = 'https://www.qa.ameriprise.com/api/advisorsv22/json/'
      break
    case 'localhost:8080cms':
      base = 'http://localhost:8080/site/_cmsinternal/ampmicrosites/'
      baseGallery = '/site/binaries/'
      menuBase = 'http://localhost:8080/site/_cmsinternal/cfgapi/hst/menus/local-ampmicrosites/'
      menuBaseWithParams =
        'http://localhost:8080/site/_cmsinternal/cfgapi/hst/menus-ext/local-ampmicrosites/'
      break
    case 'localhost:8081cms':
      base = 'http://localhost:8081/site/_cmsinternal/ampmicrosites/'
      baseGallery = '/site/binaries/'
      menuBase = 'http://localhost:8081/site/cfgapi/hst/menus/local-ampmicrosites/'
      menuBaseWithParams = 'http://localhost:8081/site/cfgapi/hst/menus-ext/local-ampmicrosites/'
      break
    case 'localhostpreview':
      base = 'http://localhost:8080/site/ampmicrosites/preview/'
      baseGallery = '/site/binaries/'
      menuBase = 'http://localhost:8080/site/cfgapi/hst/menus/local-ampmicrosites/preview/'
      menuBaseWithParams =
        'http://localhost:8080/site/cfgapi/hst/menus-ext/local-ampmicrosites/preview/'
      advisor = 'https://www.qa.ameriprise.com/api/advisorsv22/json/'
      break
    case 'localhost:8081':
      base = 'http://localhost:8081/site/ampmicrosites/'
      baseGallery = '/site/binaries/'
      menuBase = 'http://localhost:8081/site/cfgapi/hst/menus/local-ampmicrosites/'
      menuBaseWithParams = 'http://localhost:8081/site/cfgapi/hst/menus-ext/local-ampmicrosites/'
      advisor = 'https://www.qa.ameriprise.com/api/advisorsv22/json/'
      break
    case 'localhost:6006':
      base = '/microsite/'
      baseGallery = '/binaries/'
      menuBase = '/cfgapi/hst/menus/ampmicrosites/'
      menuBaseWithParams = '/cfgapi/hst/menus-ext/ampmicrosites/'
      break
    case 'localhost:9100':
      base = 'https://www.qa.ameriprise.com/microsite/'
      baseGallery = 'https://www.qa.ameriprise.com/microsite/binaries/'
      menuBase = 'https://www.qa.ameriprise.com/cfgapi/hst/menus/ampmicrosites/'
      menuBaseWithParams = 'https://www.qa.ameriprise.com/cfgapi/hst/menus-ext/ampmicrosites/'
      break
    case 'devcms':
    case 'qawscms':
    case 'qacms':
    case 'prodcms':
      base = '/site/_cmsinternal/microsite/'
      baseGallery = '/site/_cmsinternal/binaries/'
      menuBase = '/site/_cmsinternal/cfgapi/hst/menus/ampmicrosites/'
      menuBaseWithParams = '/site/_cmsinternal/cfgapi/hst/menus-ext/ampmicrosites/'
      break
    case 'dev':
      base = '/microsite/'
      baseGallery = '/binaries/'
      menuBase = '/cfgapi/hst/menus/ampmicrosites/'
      menuBaseWithParams = '/cfgapi/hst/menus-ext/ampmicrosites/'
      advisor = 'https://www.qa.ameriprise.com/api/advisorsv22/json/'
      break
    case 'qaws':
    case 'qa':
    case 'prod':
      base = '/microsite/'
      baseGallery = '/binaries/'
      menuBase = '/cfgapi/hst/menus/ampmicrosites/'
      menuBaseWithParams = '/cfgapi/hst/menus-ext/ampmicrosites/'
      advisor = '/api/advisorsv22/json/'
      break
    case 'devpreview':
    case 'qawspreview':
    case 'qapreview':
    case 'prodpreview':
      base = '/microsite/preview/'
      baseGallery = '/binaries/'
      menuBase = '/cfgapi/hst/menus/ampmicrosites-preview/'
      menuBaseWithParams = '/cfgapi/hst/menus-ext/ampmicrosites-preview/'
      advisor = 'https://www.qa.ameriprise.com/api/advisorsv22/json/'
      break
  }
  return { base, baseGallery, menuBase, menuBaseWithParams, advisor }
}

export const APIENDPOINTforCareers = (env: string) => {
  let base = ''
  let baseGallery = ''
  let menuBase = ''
  let menuBaseWithParams = ''
  let advisor = ''
  switch (env) {
    case 'localhost:8080':
      base = 'http://localhost:8080/site/joinameriprise/'
      baseGallery = '/site/binaries/'
      menuBase = 'http://localhost:8080/site/cfgapi/hst/menus/local-joinameriprise/'
      menuBaseWithParams = 'http://localhost:8080/site/cfgapi/hst/menus-ext/local-joinameriprise/'
      advisor = 'https://www.qa.ameriprise.com/api/advisorsv22/json/'
      break
    case 'localhost:8080cms':
      base = 'http://localhost:8080/site/_cmsinternal/joinameriprise/'
      baseGallery = '/site/binaries/'
      menuBase = 'http://localhost:8080/site/_cmsinternal/cfgapi/hst/menus/local-joinameriprise/'
      menuBaseWithParams =
        'http://localhost:8080/site/_cmsinternal/cfgapi/hst/menus-ext/local-joinameriprise/'
      break
    case 'localhost:8081cms':
      base = 'http://localhost:8081/site/_cmsinternal/joinameriprise/'
      baseGallery = '/site/binaries/'
      menuBase = 'http://localhost:8081/site/cfgapi/hst/menus/local-joinameriprise/'
      menuBaseWithParams = 'http://localhost:8081/site/cfgapi/hst/menus-ext/local-joinameriprise/'
      break
    case 'localhostpreview':
      base = 'http://localhost:8080/site/joinameriprise/preview/'
      baseGallery = '/site/binaries/'
      menuBase = 'http://localhost:8080/site/cfgapi/hst/menus/local-joinameriprise/preview/'
      menuBaseWithParams =
        'http://localhost:8080/site/cfgapi/hst/menus-ext/local-joinameriprise/preview/'
      advisor = 'https://www.qa.ameriprise.com/api/advisorsv22/json/'
      break
    case 'localhost:8081':
      base = 'http://localhost:8081/site/joinameriprise/'
      baseGallery = '/site/binaries/'
      menuBase = 'http://localhost:8081/site/cfgapi/hst/menus/local-joinameriprise/'
      menuBaseWithParams = 'http://localhost:8081/site/cfgapi/hst/menus-ext/local-joinameriprise/'
      advisor = 'https://www.qa.ameriprise.com/api/advisorsv22/json/'
      break
    case 'devcms':
    case 'qawscms':
    case 'qacms':
    case 'prodcms':
      base = '/site/_cmsinternal/careers/'
      baseGallery = '/site/_cmsinternal/binaries/'
      menuBase = '/site/_cmsinternal/cfgapi/hst/menus/careers/'
      menuBaseWithParams = '/site/_cmsinternal/cfgapi/hst/menus-ext/careers/'
      break
    case 'dev':
      base = '/careers/'
      baseGallery = '/binaries/'
      menuBase = '/cfgapi/hst/menus/careers/'
      menuBaseWithParams = '/cfgapi/hst/menus-ext/careers/'
      advisor = 'https://www.qa.ameriprise.com/api/advisorsv22/json/'
      break
    case 'qaws':
    case 'qa':
    case 'prod':
    case 'localhost:3000':
      base = '/careers/'
      baseGallery = '/binaries/'
      menuBase = '/cfgapi/hst/menus/careers/'
      menuBaseWithParams = '/cfgapi/hst/menus-ext/careers/'
      advisor = '/api/advisorsv22/json/'
      break
    case 'devpreview':
    case 'qawspreview':
    case 'qapreview':
    case 'prodpreview':
      base = '/careers/preview/'
      baseGallery = '/binaries/'
      menuBase = '/cfgapi/hst/menus/careers-preview/'
      menuBaseWithParams = '/cfgapi/hst/menus-ext/careers-preview/'
      advisor = 'https://www.qa.ameriprise.com/api/advisorsv22/json/'
      break
  }
  return { base, baseGallery, menuBase, menuBaseWithParams, advisor }
}

export const checkRouteForCareers = (url: string) =>
  url.includes('joinameriprise') || url.includes('careers')

export const CONSTs = {
  PRODUCTION: 'production',
  QA: 'qa',
  DEV: 'dev',
  LOCAL: 'local',
  PREVIEW: 'preview',
  UNKNOWN: 'unknown',
  POPOVER_CLASS: 'Popover',
  IS_VISIBLE_CLASS: 'is-visible',
}

export function getEnvironment(): string {
  const isLocal =
    /localhost|127\.0\.0\.1/i.test(window.location.toString()) || window.location.port === '8081'
  const isAmeriprisePublicSite =
    /(www|www1)(-ws1|preview|demo)?(\.qa.stage|\.qa|.dev)?\.ameriprise\.com/.test(
      window.location.toString()
    )
  const isAnyLower =
    /dev|ws1.dev|qa|ws1.qa|qa.stage|preview|127\.0\.0\.1|local/i.test(window.location.toString()) ||
    window.location.port === '8081'
  const isAmpLower = isAmeriprisePublicSite && isAnyLower
  const isProd = !isAnyLower && !isAmpLower
  const isDev = /dev|ws1.dev\./i.test(window.location.toString())
  const isQa = /qa|ws1.qa\./i.test(window.location.toString())
  const isPreview = /preview\./i.test(window.location.toString())

  switch (true) {
    case isProd:
      return CONSTs.PRODUCTION
    case isLocal:
      return CONSTs.LOCAL
    case isQa:
      return CONSTs.QA
    case isDev:
      return CONSTs.DEV
    case isPreview:
      return CONSTs.PREVIEW
    default:
      return CONSTs.UNKNOWN
  }
}

export const getNavItems = (halItems: never[], showOptOut: any) => {
  const navItems = halItems || []
  if (showOptOut) {
    return navItems
  }
  return filterOptOut(navItems)
}

export const filterOptOut = (navItems: any[]) =>
  navItems.filter(currMenu => currMenu.text !== 'Do Not Sell or Share My Personal Data')

export function decodeHtml(html: string | Node) {
  const txt = document.createElement('textarea')
  txt.innerText = DOMPurify.sanitize(html, { ADD_ATTR: ['target'] })
  return txt.innerText
}

export function decodeEntities(encodedString: string) {
  const translateRe = /&(nbsp|amp|quot|lt|gt);/g
  const translate = {
    nbsp: ' ',
    amp: '&',
    quot: "'",
    lt: '<',
    gt: '>',
  }
  return encodedString
    .replace(translateRe, function (match, entity) {
      return translate[entity as keyof typeof translate]
    })
    .replace(/&#(\d+);/gi, function (match, numStr) {
      const num = parseInt(numStr, 10)
      return String.fromCharCode(num)
    })
}

export function sanitizeHTML(data: string | Node) {
  return DOMPurify.sanitize(decodeEntities(decodeHtml(data)), { ADD_ATTR: ['target'] })
}

export const fetchAPIKeys = async () => {
  let API_HTMLPDF_KEY, GOOGLE_API_KEY
  const env = getCWPEnvironmentForURL(window.location.href)
  const url = `${APIENDPOINT(env).base}halapi/resourcebundles/ampmicrosites.apikeys`
  try {
    const response = await fetch(url)
    const data = await response.json()
    if (data?.bundles?.default) {
      API_HTMLPDF_KEY = data.bundles.default['API_HTMLPDF_KEY']
      GOOGLE_API_KEY = data.bundles.default['GOOGLE_API_KEY']
    }
  } catch (error) {
    console.error(error)
  }
  return { API_HTMLPDF_KEY, GOOGLE_API_KEY }
}

export const getMicrositeBase = () => {
  const env = getCWPEnvironmentForURL(window.location.href)
  const baseURL = APIENDPOINT(env).base
  if (window.location.href.split(baseURL)[1]) {
    const appname = `${window.location.href.split(baseURL)[1].split('/')[0]}`
    return appMenuNames.has(appname) && `${baseURL}${appname}`
  }
  return false
}

/**
 * @param {String} query
 *
 * parseQuery('foo&bar=baz&greeting=Hello%2C%20World!')
 * // { foo: true, bar: 'baz', greeting: 'Hello, World!' }
 */
export function parseQuery(query = '') {
  const result: Record<string, any> = {}
  if (!query.length) return result
  query
    .replace(/^\?/, '')
    .split('&')
    .forEach(item => {
      const parts = item.split('=')
      const key = parts[0]
      const value = parts[1]

      result[key] = value ? decodeURIComponent(value) : true
    })

  return result
}

export const addBaseDomain = (content: string) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(content, 'text/html')

  const env = getCWPEnvironmentForURL(window.location.href)
  const isCareers = checkRouteForCareers(window.location.href)
  const base = !isCareers ? APIENDPOINT(env).base : APIENDPOINTforCareers(env).base

  doc.querySelectorAll('a').forEach(a => {
    const href = a.getAttribute('href')
    if (href && !href.startsWith('http') && !href.includes('tel:') && !href.includes('mailto:')) {
      const baseUrl = href.startsWith('/') ? base.slice(0, -1) : base
      a.setAttribute('href', baseUrl + href)
    }
  })

  return doc.body.innerHTML
}

/*
 * Fetch POST data to the given URL
 * postDataToService({
 *     url: '/email/api',
 *     data: {}
 * }, callbackFn)
 *
 * @param {Object} with url and data to post
 * @returns response in the callback method
 */
export function postDataToService(args: any) {
  let headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
  if (args.headers) {
    headers = {
      ...headers,
      ...args.headers,
    }
  }
  return fetch(isValidUrl(args.url), {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(args.data),
  }).then(response => response.json())
}
